/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ComplianceTimelinePartner = {
    Mangopay: 'MANGOPAY',
    Aria: 'ARIA',
    Malt: 'MALT',
    None: 'NONE'
} as const;
export type ComplianceTimelinePartner = typeof ComplianceTimelinePartner[keyof typeof ComplianceTimelinePartner];


export function instanceOfComplianceTimelinePartner(value: any): boolean {
    for (const key in ComplianceTimelinePartner) {
        if (Object.prototype.hasOwnProperty.call(ComplianceTimelinePartner, key)) {
            // @ts-ignore
            if (ComplianceTimelinePartner[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ComplianceTimelinePartnerFromJSON(json: any): ComplianceTimelinePartner {
    return ComplianceTimelinePartnerFromJSONTyped(json, false);
}

export function ComplianceTimelinePartnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceTimelinePartner {
    return json as ComplianceTimelinePartner;
}

export function ComplianceTimelinePartnerToJSON(value?: ComplianceTimelinePartner | null): any {
    return value as any;
}

